import _Badge from "@material-ui/core/esm/Badge";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './color.scss';
function Color({
  color,
  name,
  className,
  activeClassName = '',
  clickableClassName = '',
  onClick,
  onMouseOut,
  onMouseOver,
  isActive,
  isActionable,
  title,
  showTooltip,
  tooltipText = undefined,
  index,
  badgeContent = undefined,
  isDisabled = false,
  isLimitedEdition,
  badgeClassName = '',
  customColor = ''
}) {
  const isColorExisted = color !== '#';
  const dataIndex = index != null ? index : name;

  // TODO: Check if onClick will work properly for mobile
  // Issue with onClick which emits click event twice
  // Possible solution:
  // onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
  return /*#__PURE__*/React.createElement(_Badge, {
    max: 999,
    showZero: true,
    badgeContent: badgeContent,
    invisible: !badgeContent,
    classes: {
      badge: classes.badge
    },
    className: badgeClassName
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.color, className, {
      [classes.colorActive]: isActive,
      [activeClassName]: isActive,
      [classes.clickable]: isActionable,
      [classes.disabled]: isDisabled,
      [clickableClassName]: isActionable,
      [classes.tooltip]: showTooltip,
      [classes.isLimitedEdition]: isLimitedEdition && isActive
    }, {
      [classes.noColor]: !isColorExisted
    }),
    style: {
      color: customColor,
      backgroundColor: isColorExisted ? color : 'transparent'
    },
    onClick: onClick,
    title: title || '',
    "data-tooltip": tooltipText || name,
    "data-colorname": name,
    "data-index": dataIndex,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    tabIndex: onClick && !isDisabled ? 0 : -1,
    "aria-label": `Color ${tooltipText || name}`,
    onKeyDown: e => handleOnEnterPressed(e, onClick)
  }, "\xA0"));
}
Color.propTypes = {
  color: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  clickableClassName: PropTypes.string,
  onClick: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseOver: PropTypes.func,
  isActive: PropTypes.bool,
  isActionable: PropTypes.bool,
  title: PropTypes.string,
  showTooltip: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Color;